<template>
  <div>
    <hero />
    <vision articleId="5fb3a0c034941d755a466008" />
    <geurs />
    <part4></part4>
    <data-area></data-area>
    <skills-area></skills-area>
  </div>
</template>
<script>
import Hero from '@/components/home/Hero';
import Vision from '@/components/home/Vision';
import Geurs from '@/components/home/Geurs';
import Part4 from '@/components/home/Part4';
import DataArea from '@/components/home/DataArea';
import SkillsArea from '@/components/home/SkillsArea';

export default {
  components: {
    Hero,
    Vision,
    Geurs,
    Part4,
    DataArea,
    SkillsArea
  }
};
</script>

<style lang="scss" scoped></style>
